// @ts-nocheck
import common from "@store/Themes/common";
import { setThemeCollection } from "@toolkit/Framework/ThemeConfiguration";

const themes = { common };

export type ThemeName = keyof typeof themes;
export default setThemeCollection(themes, "common");
